<template>
  <div class="header-container">
    <link rel="stylesheet" id="jquery-ui-theme-css"
          href="https://ajax.googleapis.com/ajax/libs/jqueryui/1.11.4/themes/cupertino/jquery-ui.min.css"
          type="text/css" media="all">
    <header :class="{'header-limited-width': isPagesWithBasket}">
      <a href="https://www.copenhagenluggageservice.com/" v-if="!isLinkList"><img src="../assets/images/luggage_service_logo.png"></a>
      <img v-else @click="openLinkList = !openLinkList" src="../assets/images/luggage_service_logo.png">
      <div class="link-list" v-if="openLinkList">
        <ul>
          <li><a href="/">Booking start page</a></li>
          <li><a href="https://www.copenhagenluggageservice.com/">Home page</a></li>
        </ul>
        <p font-size="50%">v20251118</p>
      </div>
      <slot v-if="isBook">
        <button class="book-btn" @click="scrollToService()">Book</button>
      </slot>
      <slot v-else-if="typeof (isBook) === 'undefined'">
        <div></div>
      </slot>
      <slot v-else>
        <Popup :header='"Basket"' :isArrival='isArrival'/>
      </slot>
    </header>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import Popup from '@/components/Popup'

export default {
  name: 'Header',
  components: { Popup },
  props: ['isBook', 'isArrival'],
  data: () => ({
    openLinkList: false
  }),
  computed: {
    isLinkList () {
      return this.$route.path !== '/'
    },
    isPagesWithBasket () {
      return this.$route.path === '/arrival-info' ||
      this.$route.path === '/delivery-info' ||
      this.$route.path === '/order-details' ||
      this.$route.path === '/payment-form' ||
      this.$route.path === '/storage-info' ||
      this.$route.path === '/traveller-info'
    }
  },
  methods: {
    ...mapMutations(['setCloseAllPopups']),
    scrollToService () {
      const elemPos = document.querySelector('#service').offsetTop
      window.scrollTo({ top: elemPos - 30, behavior: 'smooth' })
      this.setCloseAllPopups(true)
      setTimeout(() => {
        this.setCloseAllPopups(false)
      }, 10)
    }
  }
}
</script>

<style scoped lang="scss">
  .header-container {
    --header-height: 88px;
    --header-offset: -88px;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    width: 100%;
    height: var(--header-height);
    margin-bottom: var(--header-offset);
    background: linear-gradient(135deg, #08afe0 0%, #0098ce 100%);
    box-shadow: 0 3px 14px rgba(20, 61, 82, 0.2);
    z-index: 9999;
  }

  header {
    color: #9f9c9c;
    height: 100%;
    padding: 12px 20px;
    margin: 0 auto;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    width: 100%;
    max-width: 1024px;
    @media screen and (max-width: 800px) {
      gap: 12px;
    }
    @media (min-width: 800px) and (max-width: 1023px) {
      justify-content: space-between;
    }
    @media screen and (min-width: 1023px) {
      justify-content: space-between;
      padding: 20px;
    }
    img {
      cursor: pointer;
    }
  }

  .header-limited-width {
    @media screen and (min-width: 1023px) {
      width: auto;
      margin-left: 15%;
      margin-right: calc(15% - 20px);
    }
    @media screen and (min-width: 1435px) {
      margin-left: calc(15% + 20px);
      margin-right: 15%;
    }
  }

  .link-list {
    position: absolute;
    left: 0;
    top: 100%;
    width: 300px;
    height: calc(100vh - var(--header-height));
    height: calc(100dvh - var(--header-height));
    background-color: #00a9e0;
    z-index: 100;
    font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
    padding-top: 10px;
    @media screen and (min-width: 1023px) {
      left: 13%;
    }
    ul {
      margin: 10px 30px;
    }
    li {
      color: white;
      list-style-type: none;
      margin-bottom: 30px;
      text-transform: none;
      font-size: 26px;
      cursor: pointer;
      a {
        text-decoration: none;
        color: white;
      }
    }
  }

  header img {
    display: block;
    width: 176px;
    margin: 0;
    height: auto;
  }

  header button {
    border: 2px solid #ffffff;
    width: 150px;
    height: 46px;
    color: #fff;
    font-weight: 600;
    font-size: 18px;
    border-radius: 10px;
    cursor: pointer;
    text-transform: uppercase;
    background-color: #FC9000;
    margin-bottom: 5px;
  }

  p {
    width: auto;
    height: 3em;
    display: block;
    padding: 0.8em 1em;
    margin: 0px 20px 10px 0px;
    border: 1px solid #cccccc;
    color: #fff;
    text-align: center;
    font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
    font-weight: 300;
    font-size: 15px;
    letter-spacing: 0.1rem;
  }

  header > p::after {
    top: 40px;
    padding-left: 5px;
    font-family: FontAwesome;
    content: "\f291";
    color: #ffffff;
    cursor: pointer;
  }

  @media screen and (max-width: 484px) {
    .header-container {
      --header-height: 76px;
      --header-offset: -76px;
    }

    p {
      font-size: 13px;
      padding: 0.8em 0.4em 0.8em 0.4em;
      letter-spacing: 0.1rem;
    }

    header img {
      width: 154px;
    }
  }

  @media screen and (max-width: 360px) {
    .header-container {
      --header-height: 72px;
      --header-offset: -72px;
    }

    p {
      font-size: 11px;
      letter-spacing: 0.05rem;
    }

    header button {
      width: 112px;
      height: 40px;
      font-weight: normal;
    }

    header img {
      width: 142px;
    }
  }

  @media screen and (max-width: 280px) {
    p {
      font-size: 10px;
    }
  }

  p img {
    width: 1.22em;
    height: 1.22em;
  }

  .book-btn {
    margin-right: 20px;
  }
</style>
